import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { clicksService } from "@/services/ClicksService";

/**
 * One filter field's values for the filter bar's editor, fetched only while it
 * is open. Top values (no query) refresh with the nightly rebuild; a search
 * stays good for an hour. A failure stays inside the editor - a broken value
 * list used to take the whole page down.
 */
export const useFilterValues = (field: string, query: string, enabled: boolean) =>
  useQuery({
    queryKey: ["clicks", "filter-values", field, query],
    queryFn: () => clicksService.searchFilterValues(field, query),
    enabled,
    staleTime: 1000 * 60 * (query ? 60 : 10),
    placeholderData: keepPreviousData,
    retry: 1,
    throwOnError: false,
  });
